/**
 * the runfest.js defines the properties of the ufp-module RUNtimemaniFEST
 * @type {{name: string}}
 */

const Runfest = {
    name: 'ufp-mock',
    description: 'Utility Collection to be used for storing ufp middleware requests for mocking use later on',

    onRegistered() {

        // todo: implement configuration using the config module only

        // todo: link into middleware, presumably using middle middleware approach ... ;/

        // send back data to ufp webpack dev server   module
    }

}

export default Runfest
